import { PatchTemplateData } from "../Data/PatchTemplateData";

export class PatchData {
    public readonly template: PatchTemplateData;
    public readonly asset: string;
    public readonly sheet: string;
    public readonly rotation: number;
    public readonly scale: number;
    public readonly allowDecal: boolean;
    public readonly rampIndex: number | undefined;

    constructor(pTemplate: PatchTemplateData, pAsset: string, pSheet: string, pRotation: number, pScale: number,
                pAllowDecal: boolean, pRampIndex?: number) {
        this.template = pTemplate;
        this.asset = pAsset;
        this.sheet = pSheet;
        this.rotation = pRotation;
        this.scale = pScale;
        this.allowDecal = pAllowDecal;
        this.rampIndex = pRampIndex;
    }
}
